// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"261":"04d004cc","642":"5dcd3f19"}[chunkId] + ".js";
};